// Hit micro-feedback — pure mapping from an enemy's decaying hit-flash timer to a punchy
// size + brightness pop at the moment of impact, easing back to normal as the flash fades.
// Render-only: the renderer reads e.flash (set on every hit) and scales the sprite. No sim impact.

/** The value the sim sets enemy.flash to on each hit (combat.ts) — used to normalize freshness. */
export const FLASH_MAX = 0.12

/**
 * Sprite size + brightness multipliers for an enemy given its flash freshness (0 = no recent hit,
 * 1 = struck this instant). Pops out on impact then eases to identity {1, 1}. Pure + clamped.
 */
export function hitPop(flashFrac: number): { scale: number; bright: number } {
  const f = Math.max(0, Math.min(1, flashFrac))
  return { scale: 1 + f * 0.22, bright: 1 + f * 1.6 }
}
